function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

export default function merge(arrays) {
  return Array.from(flatten(arrays));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/merge.js
// module id = 422
// module chunks = 0